<template>
    <input autocomplete="off" type="text"
           ref="input"
           :value="value"
           :emit="emit"
           :disabled="disabled"
           @change="updateValue($event.target.value)"
           placeholder="--/--/----"
           class="filterInput">
</template>

<script>
    import moment from 'moment';
    import {validDate} from 'components/form/validator/validations';

    /**
     * Anything before this year is 20xx after is 19xx
     * @type {Number}
     */
    const DATE_CUT_OFF_YEAR = 30;
    /**
     * Stick a "0" to the left of date parts that need it.
     *
     * @param {string} datePart
     * @return {string}
     */
    const padDate = datePart => (datePart.length === 1 ? '0' + datePart : datePart);

    /**
     * Extract the dates parts from a string, any missing parts are blank strings
     *
     * @param {string} value
     * @return {{day: string, month: string, year: string}}
     */
    const dateParts = (value) => {
        // If we have slashes, these may have been added by user so pad all but the last one
        if (~value.indexOf('/')) {
            let parts = value.split("/");
            value = parts.map((part, i) => i < parts.length - 1 ? padDate(part) : part)
                .join("/");
        }

        // Find just the digits
        let numberValue = value.replace(/[^0-9]/g, '');

        // Break up string into expected lengths, if they are not present they will be empty strings
        let day = numberValue.substr(0, 2);
        let month = numberValue.substr(2, 2);
        let year = numberValue.substr(4, 4);
        return {day, month, year};
    };

    /**
     *  Date picker control that integrates with v-model. Will only update the model when the date is valid.
     */
    export default {
        name: 'date-input',
        props: {
            value: {
                type: String,
                default: ''
            },
            emit: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            /**
             * On change function does some tidying when the user has finished typing
             * Can also check if the date is only two digits and adds the correct date prefix
             *
             * @param value
             */
            updateValue(value) {
                // Date parts
                let parts = dateParts(value);

                // If the year is exactly two digits
                if (parts.year.length === 2) {
                    let yearPreFix = parseInt(parts.year, 10) < DATE_CUT_OFF_YEAR ? "20" : "19";
                    parts.year = yearPreFix + parts.year;
                }

                // Format the string
                let dateStr = [
                    // If the day has length of 2 and we have started typing month, add the trailing slash
                    // otherwise keep user entered value
                    parts.day.length === 2 && parts.month ? parts.day + '/' : parts.day,
                    // If the month has length of 2 and we have started typing year, add the trailing slash
                    // otherwise keep user entered value
                    parts.month.length === 2 && parts.year ? parts.month + '/' : parts.month,
                    // Year will always be the end
                    parts.year
                ].join('');

                // If not valid
                if (!validDate(dateStr)) {
                    // Use empty string to signal invalid value
                    this.$emit('input', dateStr);

                    // Make sure we do not write of the users value
                    this.$refs.input.value = value;
                    return;
                }

                // Our formatted version works \o/ so update the model
                this.$refs.input.value = dateStr;
                this.$emit('input', dateStr);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// LostYearsDOBDateInput.vue?6a619488